import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userActivation } from '../../redux/actions/authActions';
import { Box, Typography } from '@mui/material';
import PageLoaderComp from '../pageLoaderComp';
import { Link, useParams } from 'react-router-dom';
import './Styles.scss';

const ActivateAccountComp = () => {
  const [isValid, setIsValid] = useState(false);
  const [messageRes, setMessageRes] = useState("");
  const dispatch = useDispatch();
  const params = useParams();
  const { pageloading } = useSelector((state) => state.auth);
 
  useEffect(() => {
    const validateLink = async () => {
        const data = await dispatch(userActivation(params.activatekey));
        setIsValid(data.success);
        if(data.success){
          setMessageRes(data.message);
        }
    };
    validateLink();
}, [params.activatekey, dispatch]);
 
  return (
      
    <Box>
        {
            pageloading?<PageLoaderComp />:""
        }
        
        <Box
        className="loginMain"
        >
          <Box className="loginBoxInn">
            <Typography component="h1" variant="h4" mb={2}>
                Thank you!
            </Typography>
            <Typography component="h5" variant="h5" mb={2}>
                {messageRes}
            </Typography>
            <Box textAlign={"center"} style={{ color: '#8BAF91' }}>
                <Link to="/login" style={{ color: '#8BAF91' }} variant="body2">
                    Back to Login
                </Link>
              </Box>
            </Box>
        </Box>
    </Box>
  );
};

export default ActivateAccountComp;
